export default path => ['/', '/home'].includes(path)
